const ports = [
  {
    name: 'Shanghai Port',
    code: 'CNSHA',
    rank: '#1 World',
    icon: 'ri-ship-2-line',
    regions: ['East Africa', 'West Africa', 'South America', 'Europe'],
    transit: '18–28 days to Africa',
    products: ['Coils', 'Plates', 'Pipes', 'Beams'],
    highlight: true,
  },
  {
    name: 'Tianjin Port',
    code: 'CNTXG',
    rank: 'North China Hub',
    icon: 'ri-anchor-line',
    regions: ['Middle East', 'South Asia', 'Southeast Asia'],
    transit: '12–20 days to Middle East',
    products: ['Rebar', 'Wire Rod', 'Structural Steel'],
    highlight: false,
  },
  {
    name: 'Guangzhou Port',
    code: 'CNGZH',
    rank: 'South China Hub',
    icon: 'ri-map-pin-2-line',
    regions: ['Southeast Asia', 'Australia', 'West Africa'],
    transit: '10–18 days to SE Asia',
    products: ['Roofing Sheets', 'GI Coils', 'Mesh'],
    highlight: false,
  },
  {
    name: 'Qingdao Port',
    code: 'CNTAO',
    rank: 'Top 10 World',
    icon: 'ri-sailboat-line',
    regions: ['Middle East', 'East Africa', 'Europe'],
    transit: '15–22 days to Middle East',
    products: ['Pipes', 'Plates', 'Angles'],
    highlight: false,
  },
  {
    name: 'Ningbo Port',
    code: 'CNNGB',
    rank: '#3 World',
    icon: 'ri-ship-line',
    regions: ['Americas', 'Europe', 'Southeast Asia'],
    transit: '20–30 days to Americas',
    products: ['Coils', 'Tubes', 'Wire Mesh'],
    highlight: false,
  },
];

const destinations = [
  { region: 'West Africa', flag: '🌍', ports: 'Lagos, Tema, Abidjan', transit: '20–28 days', via: 'Shanghai / Guangzhou' },
  { region: 'East Africa', flag: '🌍', ports: 'Mombasa, Dar es Salaam', transit: '18–25 days', via: 'Shanghai / Qingdao' },
  { region: 'Middle East', flag: '🌏', ports: 'Dubai, Jeddah, Aqaba', transit: '12–18 days', via: 'Tianjin / Qingdao' },
  { region: 'South Asia', flag: '🌏', ports: 'Mumbai, Karachi, Chittagong', transit: '10–16 days', via: 'Tianjin / Shanghai' },
  { region: 'Southeast Asia', flag: '🌏', ports: 'Manila, Jakarta, Ho Chi Minh', transit: '7–14 days', via: 'Guangzhou / Ningbo' },
  { region: 'South America', flag: '🌎', ports: 'Santos, Callao, Buenaventura', transit: '25–35 days', via: 'Shanghai / Ningbo' },
];

export default function ShippingPortsSection() {
  return (
    <section className="py-20 bg-white" id="shipping-section">
      <div className="max-w-[1420px] mx-auto px-6">

        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 text-xs font-black px-4 py-1.5 rounded-full mb-4 tracking-widest uppercase" style={{ backgroundColor: '#e8f0fb', color: '#0a2342' }}>
            <i className="ri-ship-line" />
            FOB Shipping from China
          </div>
          <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: '#0a2342' }}>
            We Ship from 5 Major Chinese Ports
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            Depending on your destination and product type, we select the most cost-effective port to minimize your freight cost and transit time.
          </p>
        </div>

        {/* Port cards — horizontal scroll on mobile, grid on desktop */}
        <div className="flex gap-4 overflow-x-auto pb-2 mb-16 sm:grid sm:grid-cols-2 lg:grid-cols-5 sm:overflow-visible scrollbar-hide" id="shipping-section">
          {ports.map((port) => (
            <div
              key={port.name}
              className={`rounded-2xl p-5 border transition-all flex-shrink-0 w-[220px] sm:w-auto ${port.highlight ? 'border-transparent text-white' : 'border-gray-100 bg-gray-50 hover:border-gray-200'}`}
              style={port.highlight ? { backgroundColor: '#0a2342' } : {}}
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl mb-3 ${port.highlight ? 'bg-white/15' : ''}`}
                style={!port.highlight ? { backgroundColor: '#e8f0fb' } : {}}>
                <i className={`${port.icon} text-lg`} style={{ color: port.highlight ? '#7eb8f7' : '#0a2342' }} />
              </div>
              <div className={`text-xs font-bold mb-0.5 ${port.highlight ? 'text-white/50' : 'text-gray-400'}`}>{port.code}</div>
              <div className={`font-black text-sm mb-1 ${port.highlight ? 'text-white' : ''}`} style={!port.highlight ? { color: '#0a2342' } : {}}>{port.name}</div>
              <div className={`text-xs font-semibold mb-3 px-2 py-0.5 rounded-full inline-block ${port.highlight ? 'bg-white/15 text-white/80' : 'text-white'}`}
                style={!port.highlight ? { backgroundColor: '#0a2342' } : {}}>
                {port.rank}
              </div>
              <div className={`text-xs mb-3 ${port.highlight ? 'text-white/60' : 'text-gray-500'}`}>
                <i className="ri-time-line mr-1" />{port.transit}
              </div>
              <div className="flex flex-wrap gap-1">
                {port.products.map((p) => (
                  <span key={p} className={`text-xs px-1.5 py-0.5 rounded ${port.highlight ? 'bg-white/10 text-white/70' : 'bg-white text-gray-500 border border-gray-200'}`}>{p}</span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Destination transit table */}
        <div className="rounded-2xl overflow-hidden border border-gray-100">
          <div className="px-6 py-4 flex items-center gap-3" style={{ backgroundColor: '#0a2342' }}>
            <i className="ri-global-line text-lg" style={{ color: '#7eb8f7' }} />
            <h3 className="text-white font-black text-base">Estimated Transit Times by Region</h3>
            <span className="ml-auto text-white/40 text-xs">All shipments FOB · Door-to-port not included</span>
          </div>
          <div className="divide-y divide-gray-100">
            {destinations.map((d, i) => (
              <div key={d.region} className={`grid grid-cols-2 md:grid-cols-4 gap-4 px-6 py-4 items-center ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
                <div className="flex items-center gap-3">
                  <span className="text-2xl">{d.flag}</span>
                  <div>
                    <div className="font-black text-sm" style={{ color: '#0a2342' }}>{d.region}</div>
                    <div className="text-xs text-gray-400">{d.ports}</div>
                  </div>
                </div>
                <div className="hidden md:block">
                  <div className="text-xs text-gray-400 mb-0.5">Via Port</div>
                  <div className="text-sm font-semibold text-gray-700">{d.via}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-400 mb-0.5">Transit Time</div>
                  <div className="flex items-center gap-1.5">
                    <i className="ri-time-line text-xs" style={{ color: '#0a2342' }} />
                    <span className="text-sm font-black" style={{ color: '#0a2342' }}>{d.transit}</span>
                  </div>
                </div>
                <div className="hidden md:flex justify-end">
                  <a
                    href="/quote"
                    className="text-xs font-black px-4 py-2 rounded-lg text-white cursor-pointer hover:opacity-90 transition-opacity whitespace-nowrap"
                    style={{ backgroundColor: '#0a2342' }}
                  >
                    Get Freight Quote
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom note */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 px-6 py-4 rounded-xl" style={{ backgroundColor: '#f0f4fa' }}>
          <div className="flex items-center gap-3 text-sm" style={{ color: '#0a2342' }}>
            <i className="ri-information-line text-lg" style={{ color: '#1e5fa8' }} />
            <span><strong>Need door-to-door delivery?</strong> We work with trusted freight forwarders for CIF, CFR, and DDP terms on request.</span>
          </div>
          <a
            href="https://wa.me/8617671262710"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white text-sm font-black px-5 py-2.5 rounded-lg cursor-pointer transition-colors whitespace-nowrap"
          >
            <i className="ri-whatsapp-line" />Ask About Shipping
          </a>
        </div>
      </div>
    </section>
  );
}
